import React from 'react';
import PropTypes from 'prop-types';
import { StyledItem, Heading, Children } from './styled';

const InfoItem = ({ heading, children }) => {
  return (
    <StyledItem>
      <Heading>{heading}</Heading>
      <Children>{children}</Children>
    </StyledItem>
  );
};

InfoItem.propTypes = {
  heading: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired
};

export default InfoItem;
